module.exports = __webpack_public_path__ + "static/img/NISSAN.6985915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/NISSAN.png
// module id = RCnq
// module chunks = 1